import { fetchWithToken } from "../interceptor";
import { Conversation } from "./models";
export class CosmosConn {
  private createNewUser(
    accessToken: string,
    conversation: Conversation,
    mail: string
  ): Promise<any> {
    return new Promise(async (resolve) => {
      const newUser: { userId: string; conversation: Conversation[], mail: string } = {
        userId: conversation.user,
        conversation: [conversation],
        mail,
      };

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(newUser),
      };

      await fetchWithToken("/v1/history/user", requestOptions);
      resolve(true);
    });
  }

  private updateConversation(
    accessToken: string,
    conversation: Conversation,
    mail: string
  ): Promise<any> {
    return new Promise(async (resolve) => {
      const requestBody = { ...conversation, mail };

      const requestOptions = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      };
      // console.log("updateConversation", requestBody);

      await fetchWithToken(
        `/v1/history/user/${conversation.user}/conversation/${conversation.id}`,
        requestOptions
      );
      resolve(true);
    });
  }

  fetchChatHistoryInit(idUser: string): Promise<any> {
    return new Promise(async (resolve: any) => {
      fetchWithToken(`/v1/history/read/${idUser}`)
        .then((response) => response.json())
        .then((data) => {
          // tarea extraer conversaciones posicion 0
          if (data) resolve(data);
          // resolve([]);
        })
        .catch((error) => {
          console.error(error);
          resolve([]);
        });
    });
  }

  addConversation(
    accessToken: string,
    conversation: Conversation | null,
    mail: string
  ): Promise<boolean> {

    return new Promise(async (resolve: any) => {
      // Check if current user exists.
      const response = await fetchWithToken(
        `/v1/history/check/${conversation?.user || 0}`
      );
      if (response.status === 204) {
        // Create new user and add conversation
        if (conversation) await this.createNewUser(accessToken, conversation, mail);
      }

      if (response.status === 200) {
        if (conversation)
          await this.updateConversation(accessToken, conversation, mail);
      }
      resolve(true);
    });
  }

  deleteConversation(conversation: Conversation): Promise<boolean> {
    return new Promise(async (resolve: any) => {
      const requestOptions = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      };

      try {
        const response = await fetchWithToken(
          `/v1/history/user/${conversation.user}/conversation/${conversation.id}`,
          requestOptions
        );
        resolve(response.status === 200);
      } catch (error) {
        console.error("Error remove message from conversation", error);
        resolve(false);
      }
    });
  }

  deleteConversationItem(conversation: Conversation): Promise<boolean> {
    return new Promise(async (resolve: any) => {
      const requestOptions = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      };

      try {
        const response = await fetchWithToken(
          `/v1/history/user/${conversation.user}/conversation/${conversation.id}`,
          requestOptions
        );
        resolve(response.status === 200);
      } catch (error) {
        console.error("Error remove message from conversation", error);
        resolve(false);
      }
    });
  }

  evaluationConversation(
    userId: string,
    conversationId: string,
    messageId: string,
    evaluation: string,
    comment: string
  ): Promise<any> {
    return new Promise(async (resolve: any) => {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ comment }),
      };

      try {
        await fetchWithToken(
          `/v1/history/user/${userId}/conversation/${conversationId}/${messageId}/evaluate/${evaluation}`,
          requestOptions
        )
          .then((response) => response.json())
          .then((data) => {
            // tarea extraer conversaciones posicion 0
            if (data) resolve(data);
            // resolve([]);
          })
          .catch((error) => {
            console.error(error);
            resolve([]);
          });
      } catch (error) {
        console.error("Error remove message from conversation", error);
        resolve(false);
      }
    });
  }
}
